//Composite hook to determine if user has access to simulation features
// 1. the capabilities must be correct
// 2. the workspace must have dh_v2_available
import { useCapabilities } from "src/hooks/useCapabilities";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useSimulationAccess = () => {
  //is this the correct way to get workspace and their configs?
  const { workspace } = useWorkspaceContext();

  const { simulations } = useCapabilities();
  const hasDhV2enabled =
    !!workspace.config?.dh_v2_available_after_iso_8601_date &&
    new Date(workspace.config?.dh_v2_available_after_iso_8601_date) <
      new Date(); //available date is not in the future
  return {
    canAccess: hasDhV2enabled && simulations.canAccess,
    hasPermission: simulations.canAccess,
    isConfigured: hasDhV2enabled,
    configDate: workspace?.config?.dh_v2_available_after_iso_8601_date,
  };
};
